import { render } from "./SelectText.vue?vue&type=template&id=63e393c2"
import script from "./SelectText.vue?vue&type=script&lang=js"
export * from "./SelectText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__